import { render, staticRenderFns } from "./FinancialReportDetail.vue?vue&type=template&id=53e67d78&"
import script from "./FinancialReportDetail.vue?vue&type=script&lang=js&"
export * from "./FinancialReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports